import { request } from '@/api/client'
import type {
  AppointmentResponse,
  AppointmentWriteRequest,
  DayAvailabilityResponse,
  Paginated,
} from '@/api/types'

export const appointments = {
  /** Who is coming between two dates. Cancelled ones are not returned. */
  list: (from: string, to: string, signal?: AbortSignal) =>
    request<Paginated<AppointmentResponse>>('/v1/appointments', {
      query: { from, to },
      ...(signal ? { signal } : {}),
    }),

  /** Where the doctor sits and how full each day already is. */
  availability: (from: string, to: string, signal?: AbortSignal) =>
    request<Paginated<DayAvailabilityResponse>>('/v1/appointments/availability', {
      query: { from, to },
      ...(signal ? { signal } : {}),
    }),

  book: (body: AppointmentWriteRequest) =>
    request<AppointmentResponse>('/v1/appointments', { method: 'POST', body }),

  cancel: (id: string) => request<void>(`/v1/appointments/${id}`, { method: 'DELETE' }),
}
